<template>
  <ul class="form-item-list">
    <li><h3><b>향후 3개월 이내에</b> 다음과 같은 해외 위험지역으로 출국할 예정이 있습니까?</h3></li>
    <li>
      <p>1. 전쟁지역</p>
      <p>2. 미개척지(열대/한대)</p>
      <p>3. 등반산악지역</p>
    </li>
    <li class="text-center">
      <el-checkbox
        class="round"
        label="예"
        border
        v-model="yes"
        :error="formData.answer.error"
        @change="event => updateChecked(event, 'yes')"
      />
      <el-checkbox
        class="round"
        label="아니오"
        border
        v-model="no"
        :error="formData.answer.error"
        @change="event => updateChecked(event, 'no')"
      />
    </li>

    <li v-if="yes">
      <div class="detail-form">
        <el-row class="my-1">
          <element-textbox
            v-model="detail['지역'].value"
            :error="detail['지역'].error"
            :label="detail['지역'].label"
            :placeholder="detail['지역'].placeholder"
            @input="changeDetail('지역')"
          />
        </el-row>

        <el-row class="my-1">
          <element-textbox
            v-model="detail['목적'].value"
            :error="detail['목적'].error"
            :label="detail['목적'].label"
            :placeholder="detail['목적'].placeholder"
            @input="changeDetail('목적')"
          />
        </el-row>

        <el-row :gutter="20">
          <div class="label mx-0">{{ detail['출국기간'].label }}</div>
          <el-col :span="12">
            <el-input
              type="text"
              v-model="detail['출국기간'].value[0].value"
              :placeholder="detail['출국기간'].value[0].placeholder"
              @input="changeDetail('기간')"
            >
              <span slot="suffix">부터</span>
            </el-input>
          </el-col>
          <el-col :span="12">
            <el-input
              type="text"
              v-model="detail['출국기간'].value[1].value"
              :placeholder="detail['출국기간'].value[1].placeholder"
              @input="changeDetail('기간')"
            >
              <span slot="suffix">까지</span>
            </el-input>
          </el-col>
        </el-row>
      </div>
    </li>
  </ul>
</template>

<script>
import { Checkbox, Row, Col, Input } from 'element-ui';

export default {
  name: 'Departure',
  props: ['formData'],
  components: {
    [Checkbox.name]: Checkbox,
    [Row.name]: Row,
    [Col.name]: Col,
    [Input.name]: Input,
  },
  data() {
    return {
      yes: this.formData.answer.value === '예',
      no: this.formData.answer.value === '아니오',
      detail: {
        '지역': {
          label: "지역",
          placeholder: '출국예정 지역을 입력해주세요',
          value: "",
          error: "",
          validations: [
            { type: "required", message: "필수항목입니다" }
          ],
        },
        '목적': {
          label: "목적",
          placeholder: '출국목적을 입력해주세요',
          value: "",
          error: "",
          validations: [
            { type: "required", message: "필수항목입니다" }
          ],
        },
        '출국기간': {
          label: "출국기간",
          value: [
            { placeholder: '예: 2019.01.01', value: '' },
            { placeholder: '예: 2019.02.01', value: '' },
          ],
          error: "",
          validations: [
            { type: "required", message: "필수항목입니다" }
          ],
        }
      }
    }
  },
  mounted() { 
    this.$emit('update', { type: '지역', value: '' });
    this.$emit('update', { type: '목적', value: '' });
    this.$emit('update', { type: '기간', value: { '시작': '', '끝': '' } });
  },
  methods: {
    updateChecked(event, type) {
      const reverse = type === 'yes' ? 'no' : 'yes';
      this.$data[reverse] = !event;
      this.$emit('update', { type: 'answer', value: type });
    },
    changeDetail(key) {
      let updateData = {
        type: '기간',
        value: {
          '시작': '',
          '끝': '',
        }
      };

      if (key !== '기간') {
        this.$emit('update', { type: key, value: this.detail[key].value });
        return;
      }

      updateData.value = {
        ...updateData.value,
        시작: this.detail['출국기간'].value[0].value,
        끝: this.detail['출국기간'].value[1].value
      };

      this.$emit('update', updateData);
    },
  }
}
</script>

<style lang="scss" scoped>
.form-item-list {
  li {
    &.text-center {
      text-align: center;
    }
    h3 {
      font-size: 18px !important;
    }
    p {
      span.blue {
        color: #174BE6;
      }
    }
    .el-checkbox {
      &.round {
        width: 40%;
        text-align: left;

        .el-checkbox__inner {
          border-radius: 50% !important;
        }
      }
    }
  }
  .detail-form {
    h3 {
      margin-bottom: 2*$unit;
    }
    .el-row {
      margin-bottom: 2*$unit;

      &.my-1 {
        margin-bottom: $unit;
      }
      .mx-0 {
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: $unit;
      }
      .el-input {
        height: 54px;
  
        .el-input__inner {
          height: 54px;
          border-radius: 0;
        }
  
        .el-input__suffix-inner {
          line-height: 54px;
          color: #000;
        }
      }

      .element-select {
        .label {
          display: none;
        }
        .body {
          margin-top: 0;
        }
      }

      .element-radio {
        display: flex;
        justify-content: space-between;

        ul {
          li {
            margin-top: 0 !important;
            padding-right: 2*$unit;

            &::before {
              width: 1.5*$unit;
              height: 1.5*$unit;
            }
            &::after {
              width: 0.8*$unit;
              transform: rotate(-45deg) translateX(0.4rem) translateY(0.2rem);
            }
          }
        }
      }
    }
  }
}
</style>